import { GoogleOAuthProvider } from '@react-oauth/google';
import './App.css';
import { AllContexts } from './contexts/AllContexts';
import Root from './components/Root';


function App() {
  return (
    <AllContexts>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID!}>
        <Root />
      </GoogleOAuthProvider>
    </AllContexts>
  );
}

export default App;